import { useNavigate } from 'react-router-dom';
import { apiClient as defaultClient, type ApiClient } from '../api/client';
import { AppShell } from '../components/AppShell';
import { Card } from '../components/Card';
import { useOrg } from '../org/context';
import { useFocusMain } from '../a11y/useFocusMain';
import { ProjectForm, type ProjectValues } from './ProjectForm';
import { AuthedBrand } from './AuthedBrand';
import styles from './ProjectScreen.module.css';

export interface CreateProjectProps {
  client?: ApiClient;
}

export function CreateProject({ client = defaultClient }: CreateProjectProps) {
  const { currentOrg } = useOrg();
  const navigate = useNavigate();
  useFocusMain();

  const onSubmit = async (values: ProjectValues) => {
    const orgId = currentOrg?.id;
    if (!orgId) return;
    const created = await client.createProject(orgId, values);
    // No project list yet — land on the edit screen, which shows the unverified badge.
    navigate(`/projects/${created.id}/edit`, { replace: true });
  };

  return (
    <AppShell brand={<AuthedBrand />}>
      <Card>
        <h1 className={styles.heading}>Create a project</h1>
        <p className={styles.subheading}>Point TestCraft Journeys at a storefront to test.</p>
        <ProjectForm
          initialValues={{ name: '', webPropertyUrl: '', authorizedHost: '' }}
          submitLabel="Create project"
          busyLabel="Creating…"
          onSubmit={onSubmit}
        />
      </Card>
    </AppShell>
  );
}
